export default defineNuxtPlugin(() => {
  if (process.client && 'serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      const registration = await registerPwaServiceWorker()
      if (registration) {
        console.log('PWA Service Worker registered successfully with scope:', registration.scope)
      }
    })
  }
})
